import React from "react";
import { Card, Typography, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import "./BookingLineupCards.css";

const AddPlayerCard = ({ onClick, disabled }) => {
    if (disabled) {
        return null;
    }

    return (
        <Tooltip title="Add New Performer" placement="bottom">
            <div className="lineup-add-card" onClick={onClick}>
                <Card elevation={1} className="lineup-add-card-inner">
                    <div className="lineup-add-card-content">
                        <div className="lineup-add-card-icon">
                            <AddIcon />
                        </div>
                        <Typography variant="body2" className="lineup-add-card-text">
                            Add Performer
                        </Typography>
                    </div>
                </Card>
            </div>
        </Tooltip>
    );
};

export default AddPlayerCard;
